import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { PermisosTipoDocumental, Rol } from '@app/shared';


@Injectable()
export class DocumentPermissionsDataService {

  constructor(private http: HttpClient, private api: EndpointService, private toastr: ToastrService) { }

    /**
   * Consultar todos los permisos por serie o subserie o tipo documental
   *
   * @returns {Observable<TipoDocumentalPredeterminado[]>}
   * @memberof DocumentPermissionsDataService
   */
     getTypeDocumentPermissions(data:any): Observable<PermisosTipoDocumental[]> {
      return new Observable(obs => {
        this.http.post<PermisosTipoDocumental[]>(this.api.get('TrdPermissionsSpecial'), data).subscribe(
          typeDocumentaryPermissions => {
            obs.next(typeDocumentaryPermissions);
          },
          err => {
            obs.error(err);
          }
        );
      });
    }


  /**
   * Agregar un permiso de documento
   *
   * @param {FormData} documentPermission
   * @returns {Promise<boolean>}
   * @memberof DocumentPermissionsDataService
   */
  addDocumentPermissions(documentPermission: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('TrdPermissions'),
      documentPermission).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Permiso agregado correctamente');
          resolve(true);
        },
        err => {
          if(err.code == 400){
            this.toastr.warning('Error en la operación', 'Información incompleta');
          }else if(err.code != 400 && err.code != 403){
            this.toastr.error('Error en la operación', "Ha ocurrido un error inesperado");
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Modificar un permiso de documento
   *
   * @param {number} id
   * @param {any} documentPermission
   * @returns {Promise<boolean>}
   * @memberof DocumentPermissionsDataService
   */
  updateDocumentPermissions(id: number, documentPermission: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('TrdPermissions', [id]), documentPermission).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Permiso modificado correctamente');
          resolve(true);
        },
        err => {
          if(err.code == 400){
            this.toastr.warning('Error en la operación', 'Información incompleta');
          }else if(err.code != 400 && err.code != 403){
            this.toastr.error('Error en la operación', "Ha ocurrido un error inesperado");
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Eliminar una permiso de documentos
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof DocumentPermissionsDataService
   */
  deleteDocumentPermissions(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('TrdPermissions', [id])).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Permiso eliminado correctamente');
          resolve(true);
        },
        err => {
          if(err.code == 400){
            this.toastr.warning('Error en la operación', err);
          }else if(err.code != 400 && err.code != 403){
            this.toastr.error('Error en la operación', "Ha ocurrido un error inesperado");
          }
          reject(err);
        }
      );
    });
  }

    /**
   * Consulta los roles del sistema(grupos).
   *
   * @returns {Observable<Rol[]>}
   * @memberof DocumentPermissionsDataService
   */
     getRoles(): Observable<Rol[]> {
      return this.http.get<Rol[]>(this.api.get('roles'));
    }

}



// WEBPACK FOOTER //
// ./src/app/administration/documents/document-permissions/shared/document-permissions-data.service.ts